import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-to-left-icon',
  templateUrl: './navigation-arrow-to-left.component.html'
})
export class NavigationArrowToLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
